import { RemocalWidget, shouldShowRemocalWidget } from "@jsq/common-components";
import { Flex, Illustration, Text } from "@jsq/ds/core";

export const ErrorPage = () => (
  <Flex
    alignItems="center"
    justifyContent="center"
    flexDirection="column"
    css={{ height: "100vh" }}
  >
    {shouldShowRemocalWidget() && <RemocalWidget />}
    <Illustration name="no-internet" />
    <Text variant="regular-md" align="center">
      An unexpected error occurred. Please try refreshing the page, or contact support if the
      issue persists.
    </Text>
  </Flex>
);
